var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3281 3.0026H13.6615V4.33594H12.3281V13.0026C12.3281 13.3708 12.0297 13.6693 11.6615 13.6693H2.32812C1.95994 13.6693 1.66146 13.3708 1.66146 13.0026V4.33594H0.328125V3.0026H3.66146V1.0026C3.66146 0.634417 3.95994 0.335938 4.32812 0.335938H9.66146C10.0297 0.335938 10.3281 0.634417 10.3281 1.0026V3.0026ZM10.9948 4.33594H2.99479V12.3359H10.9948V4.33594ZM4.99479 1.66927V3.0026H8.99479V1.66927H4.99479Z",
    fill: "#F05D3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFileIcon);
export default __webpack_public_path__ + "static/media/delete-file-icon.5d6627e701bf3b052786d966e42ab4b4.svg";
export { ForwardRef as ReactComponent };